export default __webpack_public_path__ + "35397587f1eb2af1521cbf64f80c0c8f.svg";